import React, { useState, useContext, useEffect } from "react";
import {
  useForm,
  Controller,
  FormContext,
  useFormContext,
} from "react-hook-form";
import { Grid, Box, Paper } from "@material-ui/core";
import useStyles from "../../../themes/makeStyles";
import DateRangePicker from "../../../components/DateRangePicker";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import Autocomplete from "../../../components/AutoComplete";
import Notifications from "../../../components/Notifications";
import { default as Apiservices } from "../../../common";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import SimpleBackdrop from "../../../components/Backdrop";
import MultiSelectAutocomplete from "../../../components/MultiSelectAutoCompleteController";
import moment from "moment";
import clsx from "clsx";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import * as XLSX from "xlsx/xlsx.mjs";
import { saveAs } from "file-saver";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
    whiteSpace: "nowrap",
    td: {},
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "80vh",
    minHeight: "100px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function RebateTransactionMaster() {
  const classes = useStyles2();
  const history = useHistory();
  const methods = useForm();
  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
    triggerValidation,
  } = methods;

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  const [expandedPanel, setExpandedPanel] = React.useState({
    panel1: true,
    panel2: true,
    panel3: true,
    panel4: true,
  });

  const handleAccordionChange =
    (panel, expandedPanel) => (event, isExpanded) => {
      let expansionPanelList = {};
      expansionPanelList = expandedPanel;

      expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
      setExpandedPanel({
        panel1:
          panel === "panel1"
            ? expansionPanelList[panel]
            : expansionPanelList["panel1"],
        panel2:
          panel === "panel2"
            ? expansionPanelList[panel]
            : expansionPanelList["panel2"],
        panel3:
          panel === "panel3"
            ? expansionPanelList[panel]
            : expansionPanelList["panel3"],
        panel4:
          panel === "panel4"
            ? expansionPanelList[panel]
            : expansionPanelList["panel4"],
      });
    };
  const [displayBackDrop, setDisplayBackDrop] = useState(false);
  const [keys, setKey] = useState([]);
  const [table_data, setTabledata] = useState([]);
  const [keys_value, setKeyvalue] = useState([]);
  const [rakename, setRakename] = useState([]);
  const [zone, setZone] = useState([]);
  const [downloadData, setDownloadData] = useState();
  const [jobstatus, setJobstatus] = useState([
    "Invoice In Progress",
    "Rebate Cap",
    "Partially Invoiced",
  ]);
  const [rrStartDate, setrrStartDate] = useState(null);
  const [rrEndDate, setrrEndDate] = useState(null);

  const handleToggle = () => {
    return true;
  };

  const handleClose = () => {
    return true;
  };

  useEffect(() => {
    const fetchData = async () => {
      let filter = null;
      setDisplayBackDrop(true);
      const listsResponse = await Apiservices.getgpwrsdata(filter);
      let table_data = listsResponse;
      console.log(table_data);
      setDownloadData(table_data);
      let keys = Object.keys(table_data.length ? table_data[0] : {});
      let keys_value = Object.values(table_data.length ? table_data[0] : {});
      table_data.splice(0, 1);
      setKey(keys);
      setTabledata(table_data);
      setKeyvalue(keys_value);
      setDisplayBackDrop(false);

      const RakeResponse = await Apiservices.rebatesummaryreport(filter);
      let rake_data = RakeResponse.records;
      rake_data.splice(0, 1);

      let list_rake = rake_data.filter(
        (a, i) => rake_data.findIndex((s) => a.rake === s.rake) === i
      );
      if (list_rake) {
        let list = list_rake.map((row) => {
          return { value: row.rake, label: row.rake };
        });
        setRakename(list);
      }

      let list_zone = rake_data.filter(
        (a, i) => rake_data.findIndex((s) => a.zone === s.zone) === i
      );
      if (list_zone) {
        let list = list_zone.map((row) => {
          return row.zone;
        });
        setZone(list);
      }
    };
    fetchData();
  }, []);

  const handlerakelist = (rakes) => {
    let submitteddata = rakes;
    let temp = [];
    submitteddata.map((row) => {
      temp.push(row.value);
    });
    let RakeDetails = JSON.stringify(temp);
    RakeDetails = RakeDetails.replaceAll('","', ",");
    RakeDetails = RakeDetails.replaceAll('"', "");
    RakeDetails = RakeDetails.replaceAll("[", "");
    RakeDetails = RakeDetails.replaceAll("]", "");
    // setJobList(RakeDetails);
    return RakeDetails;
  };

  const HandleData = async () => {
    let rake = methods.getValues("rake");
    let rakeList = rake != null ? handlerakelist(rake) : null;
    let filter = {
      from_date: rrStartDate,
      to_date: rrEndDate,
      rake: rakeList != "" ? rakeList : null,
      fy: methods.getValues("fy"),
      quarter: methods.getValues("quarter"),
      operating_year: methods.getValues("operating_year"),
      zone: methods.getValues("zone"),
      job_status: methods.getValues("job_status"),
      paid_by: methods.getValues("paid_by"),
    };
    setDisplayBackDrop(true);
    const listsResponse = await Apiservices.getgpwrsdata({ filter: filter });
    // console.log("listsResponse", listsResponse);
    let table_data = listsResponse;
    setDownloadData(table_data);
    let keys = Object.keys(table_data.length ? table_data[0] : {});
    let keys_value = Object.values(table_data.length ? table_data[0] : {});
    table_data.splice(0, 1);
    setKey(keys);
    setTabledata(table_data);
    setKeyvalue(keys_value);
    setDisplayBackDrop(false);
  };
  const ExcelDownload = async () => {
    if (!downloadData) {
      setNotify({
        isOpen: true,
        message: `No Data to export`,
        type: "warning",
        timing: 3000,
      });
    } else {
      setNotify({
        isOpen: true,
        message: `Downloading..`,
        type: "success",
        timing: 3000,
      });
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(downloadData, {
        // This function transforms each cell
        cellDates: true, // If you have date fields in your downloadData
        cellNF: true, // Preserve number formats
        cellText: false, // Do not convert numbers to text
        header: Object.keys(downloadData[0]), // Ensure headers are taken from keys
      });

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Write workbook to an Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, "Reabate Summary Report.xlsx");
    }
  };

  return (
    <div>
      <Box py={1}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm>
            <Box py={2}>
              <h3 className={classes.secondHeading}>
                Rebate Transaction Master
              </h3>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <FormContext {...methods}>
        <form Validate id="clearance">
          <React.Fragment>
            <Box py={1}>
              <Paper elevation={0}>
                <Accordion
                  expanded={expandedPanel["panel2"] === true}
                  onChange={handleAccordionChange("panel2", expandedPanel)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.secondHeading}>
                      Filter By
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <MultiSelectAutocomplete
                          name={`rake`}
                          Values={rakename}
                          rules={{ required: true }}
                          error={methods.errors.rake}
                          label="Select Rake"
                          control={control}
                          methods={methods}
                        />
                        {methods.errors.rake && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="Rake"
                            name="rake"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Controller
                          as={<DateRangePicker />}
                          name="rr_start_end_date"
                          id="rr_start_end_date"
                          control={control}
                          rules={{ required: false }}
                          required={false}
                          disabled={false}
                          onChange={([value]) => {
                            // console.log(value, "date");
                            if (value.length > 0) {
                              let rr_start_end_dates = value.split("To");
                              setrrStartDate(
                                rr_start_end_dates
                                  ? moment(
                                      rr_start_end_dates[0].trim(),
                                      "DD-MM-YYYY"
                                    ).format("YYYY-MM-DD")
                                  : null
                              );
                              setrrEndDate(
                                rr_start_end_dates
                                  ? moment(
                                      rr_start_end_dates[1].trim(),
                                      "DD-MM-YYYY"
                                    ).format("YYYY-MM-DD")
                                  : null
                              );
                            }
                            return value;
                          }}
                          label="RR Date Range"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`paid_by`}
                          Values={["TMILL", "Customer"]}
                          rules={{ required: true }}
                          error={methods.errors.paid_by}
                          label="Freight Paid By"
                        />
                        {methods.errors.paid_by && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="paid_by"
                            name="paid_by"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`fy`}
                          Values={[
                            "2020-21",
                            "2021-22",
                            "2022-23",
                            "2023-24",
                            "2024-25",
                          ]}
                          rules={{ required: true }}
                          error={methods.errors.fy}
                          label="Select FY"
                        />
                        {methods.errors.fy && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="FY"
                            name="fy"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`quarter`}
                          Values={["Q1", "Q2", "Q3", "Q4"]}
                          rules={{ required: true }}
                          error={methods.errors.quarter}
                          label="Select Quarter"
                        />
                        {methods.errors.quarter && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="Quarter"
                            name="quarter"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`operating_year`}
                          Values={[
                            "2020",
                            "2021",
                            "2022",
                            "2023",
                            "2024",
                            "2025",
                          ]}
                          rules={{ required: true }}
                          error={methods.errors.operating_year}
                          label="Select Operating Year"
                        />
                        {methods.errors.operating_year && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="operating_year"
                            name="operating_year"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`zone`}
                          Values={zone}
                          rules={{ required: true }}
                          error={methods.errors.zone}
                          label="Select Zone"
                        />
                        {methods.errors.zone && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="zone"
                            name="zone"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`job_status`}
                          Values={jobstatus}
                          rules={{ required: true }}
                          error={methods.errors.job_status}
                          label="Select Job Status"
                        />
                        {methods.errors.job_status && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="job status"
                            name="job_status"
                          />
                        )}
                      </Grid>
                      <Grid item container justify="flex-end">
                        <Button
                          onClick={HandleData}
                          color="primary"
                          variant="contained"
                          className="btnMinWidthSearch"
                        // disabled={reportData}
                        >
                          Generate
                        </Button>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Paper>
            </Box>
            {table_data.length > 0 ? (
              <Box py={1}>
                <Paper elevation={0}>
                  <Accordion
                    expanded={expandedPanel["panel3"] === true}
                    onChange={handleAccordionChange("panel3", expandedPanel)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography className={classes.secondHeading}>
                        Rebate Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box width="100%">
                        <Grid container spacing={2} justify="flex-end">
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={clsx(classes.subTextButton)}
                              type="button"
                              startIcon={<CloudDownloadIcon />}
                              onClick={ExcelDownload}
                            >
                              Export to Excel
                            </Button>
                          </Grid>
                        </Grid>
                        <TableContainer
                          component={Paper}
                          className={"freezeTable"}
                        >
                          <Table
                            // className={classes.table}
                            aria-label="simple table"
                            stickyHeader
                          >
                            <TableHead>
                              <TableRow>
                                {keys_value.map((item) => (
                                  <StyledTableCell
                                    align="center"
                                    style={{ minWidth: 120 }}
                                  >
                                    <b>{item}</b>
                                  </StyledTableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {table_data.map((item, idx) => (
                                <TableRow key={idx}>
                                  {keys.map((key, idx) => (
                                    <StyledTableCell
                                      align="center"
                                      style={{ minWidth: 120 }}
                                    >
                                      {item[key]}
                                    </StyledTableCell>
                                  ))}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Box>
            ) : (
              ""
            )}
          </React.Fragment>
        </form>
        {displayBackDrop && (
          <SimpleBackdrop
            handleToggle={handleToggle}
            handleClose={handleClose}
          />
        )}
        <Notifications notify={notify} setNotify={setNotify} />
      </FormContext>
    </div>
  );
}
